module.exports = __webpack_public_path__ + "img/WFH-AGS-2025-Logo-EN.e6449fe0.png";